import { FC, useEffect } from 'react';
import { Element } from 'react-scroll';
import { FooterContainer } from '../modules/footer/footer.container';
import { NewsPage } from '../modules/news-page/news-page';

export const News: FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <Element name="news">
      <NewsPage />
      <FooterContainer />
    </Element>
  );
};
